import colors from './colors';
var textVariants = {
    error: {
        color: colors.error,
        fontWeight: '700',
    },
};
export default textVariants;
//# sourceMappingURL=textVariants.js.map